var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#8C8C8C",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7 11c-.978 0-1.916.4-2.607 1.11-.765.786-.826 1.808-.523 2.67.295.838.942 1.583 1.728 2.028q.176.1.354.185C7.33 17.652 8.627 18 9.95 18s2.621-.348 3.999-1.007q.177-.085.353-.185c.786-.445 1.434-1.19 1.728-2.028.303-.862.242-1.884-.523-2.67A3.64 3.64 0 0 0 12.9 11z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.5,
    r: 3.5,
    strokeWidth: 1.2
  })));
};
export default SvgUser;